import type { HeartRateEvent } from '@model/DeviceConfiguration';
import { formatFromSecondToMinutes } from '../../../../../utils/formatDuration';

export const formatRepairMetric = (value: number | null | undefined) =>
  typeof value === 'number' && Number.isFinite(value) ? value.toFixed(2) : '-';

export const formatRepairPercent = (value: number) => `${value.toFixed(1)}%`;

export const formatSessionEventsDuration = (events?: HeartRateEvent[]) => {
  const timestamps = (events ?? [])
    .map(event => event.timestamp)
    .filter(
      (timestamp): timestamp is number =>
        typeof timestamp === 'number' && Number.isFinite(timestamp)
    );

  if (timestamps.length < 2) return 'n/a';

  const durationSeconds = Math.round(
    (Math.max(...timestamps) - Math.min(...timestamps)) / 1000
  );

  return formatFromSecondToMinutes(durationSeconds);
};

export const formatSessionDate = (value?: string | Date | null) =>
  value ? new Date(value).toLocaleString('it-IT') : 'n/a';
